import React from 'react';

export default function StatsBar({ total, filtered, applied, interviews, offers, accent }) {
  const stats = [
    { label: 'Total Jobs',  value: total,      color: accent },
    { label: 'Showing',     value: filtered,   color: '#c8d4f0' },
    { label: 'Applied',     value: applied,    color: '#2196f3' },
    { label: 'Interviews',  value: interviews, color: '#ff9800' },
    { label: 'Offers',      value: offers,     color: '#00e896' },
  ];

  return (
    <div style={styles.bar} className="fade-up-2">
      {stats.map(s => (
        <div key={s.label} style={styles.stat}>
          <span style={{ ...styles.val, color: s.color }}>{s.value}</span>
          <span style={styles.lbl}>{s.label}</span>
        </div>
      ))}
    </div>
  );
}

const styles = {
  bar: {
    display: 'flex', gap: 0,
    background: '#0d0f1c', border: '1px solid #1a1e35',
    borderRadius: 10, overflow: 'hidden',
  },
  stat: {
    flex: 1, display: 'flex', flexDirection: 'column',
    alignItems: 'center', padding: '12px 8px',
    borderRight: '1px solid #1a1e35',
  },
  val: { fontSize: 22, fontWeight: 800 },
  lbl: {
    fontSize: 9, color: '#3a4460',
    textTransform: 'uppercase', letterSpacing: 1.5,
    marginTop: 2,
  },
};
